import React from "react";
import Style from "./../../../assets/scss/custom.module.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import UserOverview from "./tab-item/UserOverview";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../page-action/AccessPageAction";
import { viewUser, userManage } from "../../../locales/en";

const ViewUser = () => {
  return (
    <>
      <TablePagesTitle
        mainTitle={userManage.mainTitle}
        content={userManage.content}
      />
      <AccessPageAction
        subheading={viewUser.subH2}
        alluser="/admin/access/user"
        allUserTitle={userManage.activeUser}
        createuser="/admin/access/user/create"
        createUserTitle={userManage.creteUser}
        deactivate="/admin/access/user/deactivated"
        deactivateTitle={userManage.deactiveUserBtn}
        deleteuser="/admin/access/user/deleted"
        deleteUserTitle={userManage.deleteUser}
      />
      <div className="row mb-3 mx-0">
        <div
          className={`${Style.tabContainerCustom} tabcontainercustom col-md-12 mt-3`}
        >
          <Tabs defaultActiveKey="User_Overview" className="mb-3">
            <Tab eventKey="User_Overview" title={viewUser.overview}>
              <UserOverview />
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default ViewUser;
